import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`DDDTW 社群志工，持續關注各種架構與技術的發展，隨著深刻感受技術為業務服務的要旨，近年逐漸關注軟體本身的業務價值。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      